import { render, staticRenderFns } from "./Naehrstoffanalyse.vue?vue&type=template&id=783732cf&"
import script from "./Naehrstoffanalyse.vue?vue&type=script&lang=js&"
export * from "./Naehrstoffanalyse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports